<script setup>
import Home from '~/components/Icons/Home.vue';
import Selected from '~/components/Icons/Selected.vue'

const {$_, $formatNumber, $formatStreetAddress, $formatCurrency} = useNuxtApp()

const userStore = useUserStore()
const props = defineProps({
  subject: {
    type: Object,
    default: null
  }
})
const active = computed(() => userStore?.activeSubject === props.subject)
const emit = defineEmits(['close'])

async function selectSubject() {
  clearNuxtData()
  userStore.activeSubject = props.subject
  emit('close')
}
</script>
<template>
  <li v-if="subject">
    <button @click="selectSubject">
      <div class="icon">
        <Home :default-fill="!active" :icon-class="active ? 'fill-green' : ''"></Home>
        <Selected v-if="active" class="selected" />
      </div>
      <div class="info">
        <template v-if="subject?.name">
          <p>{{ subject.name }}</p>
        </template>
        <template v-else>
          <p>-</p>
        </template>
        <template v-if="subject?.address">
          <span>{{ $formatStreetAddress(subject.address) }}</span>
        </template>
        <template v-else>
          <span>-</span>
        </template>
      </div>
    </button>
  </li>
</template>
<style scoped>
span {
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(128 130 133 / var(--tw-text-opacity)) /* #808285 */;
}

button {
  border-top: 2px solid #EBECEC;
  padding: 12px 16px;
  display: flex;
  gap: 16px;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

.icon {
  position: relative;
}

.selected {
  position: absolute;
  bottom: -8px;
  right: -8px;
}

button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity));
}

.info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
}
</style>
